.open {
  > .content {
    animation-name: contentOpen;
  }

  > .overlay {
    animation-name: overlayOpen;
    animation-duration: var(--modal-animation-duration);
    animation-timing-function: var(--modal-animation-timing-function);
  }
}

.closed {
  overflow: hidden;

  > .content {
    animation-name: contentClose;
  }

  > .overlay {
    animation-name: overlayClose;
    animation-duration: var(--modal-animation-duration);
    animation-timing-function: var(--modal-animation-timing-function);
    animation-fill-mode: forwards;
  }
}

.modal {
  --modal-animation-duration: 180ms;
  --modal-animation-transform: translateY(10%);
  --modal-animation-timing-function: cubic-bezier(0.22, 1, 0.36, 1);

  composes: scrollbar from '@/stylesheets/scrollbar.module.css';
}

.modal {
  z-index: 1500;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;

  @media (min-width: 769px) {
    overflow: auto;
  }

  &.dropdown {
    @media (min-width: 769px) {
      position: absolute;
      overflow: visible;
    }

    > .overlay {
      @media (min-width: 769px) {
        display: none;
      }
    }

    > .content {
      @media (min-width: 769px) {
        width: 100%;
        margin: 0;
        box-shadow:
          0 0.625rem 1.875rem rgba(28, 30, 29, 0.1),
          0 0.25rem 0.375rem rgba(28, 30, 29, 0.05);
      }
    }
  }

  &.actionable {
    > .content {
      > .children {
        padding-bottom: 7rem;

        @media (min-width: 400px) {
          padding-bottom: 7.375rem;
        }

        @media (min-width: 769px) {
          padding-bottom: 1.75rem;
        }

        @media (min-width: 1025px) {
          padding-bottom: 2rem;
        }
      }

      > .actions {
        display: flex;

        @media (min-width: 769px) {
          border-bottom-right-radius: 3rem;
          border-bottom-left-radius: 3rem;
        }
      }
    }
  }
}

.overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(14, 33, 24, 0.42);
  transition: var(--modal-animation-duration);
}

.content {
  display: flex;
  z-index: 2500;
  position: absolute;
  bottom: 0;
  flex-direction: column;
  width: 100%;
  max-height: 85%;
  border: none;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  overflow: hidden;
  cursor: default;
  background-color: var(--neutral);
  animation-duration: var(--modal-animation-duration);
  animation-timing-function: var(--modal-animation-timing-function);
  animation-fill-mode: forwards;

  @media (min-width: 769px) {
    position: relative;
    width: 80%;
    max-width: 33rem;
    max-height: unset;
    margin: max(7%, 6.5rem) auto;
    border-radius: 0.75rem;
    overflow: hidden;
    box-shadow:
      0 2rem 5rem rgba(14, 33, 24, 0.32),
      0 0.5rem 1.5rem rgba(14, 33, 24, 0.18);
  }

  @media (min-width: 1025px) {
    max-width: 55rem;
  }
}

.close {
  display: flex;
  z-index: 200;
  position: absolute;
  top: 0.5625rem;
  right: 0.5rem;
  width: 1.75rem;
  height: 1.75rem;

  @media (min-width: 769px) {
    top: 0.75rem;
    right: 0.75rem;
  }

  svg {
    width: 1.25rem;
    height: 1.25rem;
  }
}

.title {
  padding: 1.375rem 1.25rem;
  text-align: left;

  @media (min-width: 1025px) {
    padding: 1.5rem;
  }

  + .children {
    padding-top: 0;
  }
}

.children,
.actions {
  padding-top: 1.25rem;
  padding-right: 1.25rem;
  padding-bottom: calc(1.25rem + env(safe-area-inset-bottom) * 1.5);
  padding-left: 1.25rem;
}

.children {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  overflow: auto;
  scrollbar-width: none;

  @media (min-width: 769px) {
    overflow: visible;
  }
}

.actions {
  display: none;
  z-index: 3000;
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  justify-content: space-between;
  border-top: 0.0625rem solid var(--neutral-200);
  background-color: var(--neutral);
  gap: 0.75rem;

  @media (min-width: 769px) {
    position: relative;
  }

  .cancel,
  .confirm {
    min-width: 7.25rem;
    height: 3rem;

    @media (min-width: 769px) {
      height: 3.375rem;
    }
  }

  .cancel {
    flex: 2;
  }

  .confirm {
    flex: 3;
  }
}

@keyframes overlayOpen {
  0% {
    opacity: 0;
  }
}

@keyframes overlayClose {
  100% {
    opacity: 0;
  }
}

@keyframes contentOpen {
  0% {
    opacity: 0;
    transform: var(--modal-animation-transform);
  }

  100% {
    opacity: 1;
    transform: none;
  }
}

@keyframes contentClose {
  0% {
    opacity: 1;
    transform: none;
  }

  100% {
    opacity: 0;
    transform: var(--modal-animation-transform);
  }
}
